import { IN3 } from '../../in3/sdk-wasm'

export function toRPC(val: any): any {
    if (Array.isArray(val)) return val.map(toRPC)
    switch (typeof val) {
        case 'undefined': return val
        case 'object': {
            if (val.byteLength != undefined) return IN3.util.toHex(val)
            const copy = {}
            Object.keys(val).forEach(_ => copy[_] = toRPC(val[_]))
            return copy
        }
        case 'string': return val
        case 'bigint':
        case 'number': return IN3.util.toMinHex(val)
        default: return val
    }
}


export function toBigInt(val: any) {
    return BigInt(val)
}

export function mapValues(val: any, cb: (key: string, val: any) => any) {
    if (!val) return val
    const copy = {}
    Object.keys(val).forEach(_ => copy[_] = cb(_, val[_]))
    return copy
}
